import { render } from "./AppPaymentIcon.vue?vue&type=template&id=f7517c7a"
const script = {}

import exportComponent from "/Users/kamoliddin/Documents/iWork/Valvoline/promo2025/promo2025.lubricoil.uz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__